import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import { Variables } from "../../Variables1/Variables";
import CustomSnipper from "../../components/customSnipper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Util from "../../Classes/Util";
import { BiTrashAlt, BiLowVision, BiEditAlt } from "react-icons/bi";
import Cookies from "js-cookie";
import Pagination from "../../components/Pagination";

var sortJsonArray = require("sort-json-array");

function MenuesList(props) {
  const navigate = useNavigate();
  const token = Cookies.get("token");

  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [loader, setLoader] = useState(false);
  const [menues, setMenues] = useState([]);
  const [search, SetSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [publishModalView, SetPublishModalView] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // Get Menues
  const GetMenues = async () => {
    setLoader(true);
    let response = await fetch(Variables.API_URL + `Menu/GetMenues?pageNumber=${pageNumber}&pageSize=${pageSize}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

    let result = await response.json();
    if (response.status === 200 || response.status === 204) {
      setMenues(result.Items);
      setFilteredData(result.Items);
      setTotalCount(result.TotalCount);
    }
    setLoader(false);
  };

  // handle Search
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    SetSearch(value);
    result = menues.filter((data) => {
      return (
        data.MenuTitle.toLowerCase().search(value) !== -1 ||
        data.DirectionName.toLowerCase().search(value) !== -1 ||
        data.LanguageName.toLowerCase().search(value) !== -1
      );
    });
    setFilteredData(result);
  };

  // Publish - Unpublish menu
  const PublishUnpublishMenu = async (mId) => {
    let response = await fetch(
      Variables.API_URL + "Menu/PublishUnpublishMenu/" + mId,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      SetPublishModalView(0);
      GetMenues();
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  //#region Sorting

  const [titleSort, setTitleSort] = useState("asc");
  const [directionSort, setDirectionSort] = useState("asc");
  const [orderSort, setOrderSort] = useState("asc");
  const [publishSort, setPublishSort] = useState("asc");
  const [languageSort, setLanguageSort] = useState("asc");

  // sort by title
  const SortByTitle = () => {
    var copy = [...filteredData];
    if (titleSort == "asc") {
      var x = sortJsonArray(copy, "MenuTitle", "des");
      setTitleSort("des");
    } else {
      var x = sortJsonArray(copy, "MenuTitle");
      setTitleSort("asc");
    }
    setFilteredData(x);
  };

  // sort by isPublished
  const SortByIsPublished = () => {
    var copy = [...filteredData];
    if (publishSort == "asc") {
      var x = sortJsonArray(copy, "IsPublished", "des");
      setPublishSort("des");
    } else {
      var x = sortJsonArray(copy, "IsPublished");
      setPublishSort("asc");
    }
    setFilteredData(x);
  };

  // sort by Direction
  const SortByDirection = () => {
    var copy = [...filteredData];
    if (directionSort == "asc") {
      var x = sortJsonArray(copy, "DirectionName", "des");
      setDirectionSort("des");
    } else {
      var x = sortJsonArray(copy, "DirectionName");
      setDirectionSort("asc");
    }
    setFilteredData(x);
  };

  // sort by Language
  const SortByLanguage = () => {
    var copy = [...filteredData];
    if (languageSort == "asc") {
      var x = sortJsonArray(copy, "LanguageName", "des");
      setLanguageSort("des");
    } else {
      var x = sortJsonArray(copy, "LanguageName");
      setLanguageSort("asc");
    }
    setFilteredData(x);
  };

  // sort by order
  const SortByOrder = () => {
    var copy = [...filteredData];
    if (orderSort == "asc") {
      var x = sortJsonArray(copy, "MenuOrder", "des");
      setOrderSort("des");
    } else {
      var x = sortJsonArray(copy, "MenuOrder");
      setOrderSort("asc");
    }
    setFilteredData(x);
  };

  //#endregion
 useEffect(() => {
  GetMenues();
}, [pageNumber, pageSize]);

  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Menus List</h4>
              </div>
              {Permissions.ManageMenues === true && (
                <Button variant="primary" onClick={() => navigate("/Menu/0")}>
                  Add New Menu
                </Button>
              )}
            </Card.Header>
            <Card.Body className="px-0">
              <Form.Control
                id="Search"
                name="Search"
                placeholder="Search"
                type="text"
                className="allignCenter"
                onChange={handleSearch}
              />
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th></th>
                        <th onClick={() => SortByTitle()}>Title</th>
                        <th onClick={() => SortByDirection()}>Direction</th>
                        <th onClick={() => SortByLanguage()}>Language</th>
                        <th onClick={() => SortByOrder()}>Order</th>
                        <th onClick={() => SortByIsPublished()}>IsPublished</th>
                        <th min-width="100px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((tdata, index) => (
                        <>
                          <tr key={index}>
                            <td className="text-center">{index + 1}</td>
                            {/* <td>{tdata.ImageUrl}</td> */}
                            <td>{tdata.Menu.MenuTitle}</td>
                            <td>{tdata.Menu.DirectionName}</td>
                            <td>{tdata.Menu.LanguageName}</td>
                            <td>{tdata.Menu.MenuOrder}</td>
                            <td>
                              <span
                                className={
                                  tdata.Menu.IsPublished === false
                                    ? "badge bg-danger"
                                    : "badge bg-success"
                                }
                              >
                                {tdata.Menu.IsPublished == true
                                  ? "Published"
                                  : "Unpublished"}
                              </span>
                            </td>
                            <td>
                              {Permissions.ManageMenues === true && (
                                <div className="flex align-items-center list-user-action">
                                  <Link
                                    className="btn btn-sm btn-icon btn-warning"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title=""
                                    data-original-title="Edit"
                                    to={"#"}
                                    onClick={() =>
                                      SetPublishModalView(tdata.Menu.MenuId)
                                    }
                                  >
                                    <BiLowVision />
                                  </Link>{" "}
                                  <Modal
                                    show={publishModalView == tdata.Menu.MenuId}
                                    onHide={() => SetPublishModalView(0)}
                                  >
                                    <Modal.Header closeButton>
                                      <Modal.Title as="h5">
                                        {tdata.Menu.IsPublished === true
                                          ? "Unpublish Modal"
                                          : "Publish Modal"}
                                      </Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                      Are you sure you want to{" "}
                                      {tdata.Menu.IsPublished === true
                                        ? "Unpublish"
                                        : "Publish " +
                                          tdata.Menu.MenuTitle +
                                          " ?"}
                                    </Modal.Body>
                                    <Modal.Footer>
                                      <Button
                                        variant="secondary"
                                        onClick={() => SetPublishModalView(0)}
                                      >
                                        Close
                                      </Button>
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          PublishUnpublishMenu(
                                            tdata.Menu.MenuId
                                          )
                                        }
                                      >
                                        Submit
                                      </Button>
                                    </Modal.Footer>
                                  </Modal>
                                  <Link
                                    className="btn btn-sm btn-icon btn-success"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title=""
                                    data-original-title="Edit"
                                    to={"/Menu/" + tdata.Menu.MenuId}
                                  >
                                    <span className="btn-inner">
                                      <svg
                                        width="20"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        ></path>
                                        <path
                                          fillRule="evenodd"
                                          clipRule="evenodd"
                                          d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        ></path>
                                        <path
                                          d="M15.1655 4.60254L19.7315 9.16854"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        ></path>
                                      </svg>
                                    </span>
                                  </Link>{" "}
                                </div>
                              )}
                            </td>
                          </tr>
                          {tdata.SubMenues.map((sub, i) => (
                            <tr key={index} className="background-bleu">
                              <td className="text-center"></td>
                              <td>{"-- " + sub.MenuTitle}</td>
                              <td>{sub.DirectionName}</td>
                              <td>{sub.LanguageName}</td>
                              <td>{sub.MenuOrder}</td>
                              <td>
                                <span
                                  className={
                                    sub.IsPublished === false
                                      ? "badge bg-danger"
                                      : "badge bg-success"
                                  }
                                >
                                  {sub.IsPublished == true
                                    ? "Published"
                                    : "Unpublished"}
                                </span>
                              </td>
                              <td>
                                {Permissions.ManageMenues === true && (
                                  <div className="flex align-items-center list-user-action">
                                    <Link
                                      className="btn btn-sm btn-icon btn-warning"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title=""
                                      data-original-title="Edit"
                                      to={"#"}
                                      onClick={() =>
                                        SetPublishModalView(sub.MenuId)
                                      }
                                    >
                                      <BiLowVision />
                                    </Link>{" "}
                                    <Modal
                                      show={publishModalView == sub.MenuId}
                                      onHide={() => SetPublishModalView(0)}
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title as="h5">
                                          {sub.IsPublished === true
                                            ? "Unpublish Modal"
                                            : "Publish Modal"}
                                        </Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body>
                                        Are you sure you want to{" "}
                                        {sub.IsPublished === true
                                          ? "Unpublish"
                                          : "Publish " + sub.MenuTitle + " ?"}
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button
                                          variant="secondary"
                                          onClick={() => SetPublishModalView(0)}
                                        >
                                          Close
                                        </Button>
                                        <Button
                                          variant="primary"
                                          onClick={() =>
                                            PublishUnpublishMenu(sub.MenuId)
                                          }
                                        >
                                          Submit
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                    <Link
                                      className="btn btn-sm btn-icon btn-success"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title=""
                                      data-original-title="Edit"
                                      to={"/Menu/" + sub.MenuId}
                                    >
                                      <span className="btn-inner">
                                        <svg
                                          width="20"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                          <path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                          <path
                                            d="M15.1655 4.60254L19.7315 9.16854"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                        </svg>
                                      </span>
                                    </Link>{" "}
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    pageNumber={pageNumber}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPageNumber(newPage)}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default MenuesList;
